import { ReduxHelper } from "helpers";
import {
  ICompany,
  ICreateCompanyRequest,
  ICreateLocationRequest,
  ICreatePalletsRequest,
  ICreateProductRequest,
  ICreateUserRequest,
  ICreateWarehouseRequest,
  ICreateZoneRequest,
  IDeleteByIdRequest,
  IGetByIdRequest,
  ILocation,
  IPaginateApiResponse,
  IPaginationRequest,
  IPallet,
  IProduct,
  IProductCategory,
  IUnitMeasure,
  IUpdateCompanyRequest,
  IUpdateLocationRequest,
  IUpdateProductRequest,
  IUpdateUserRequest,
  IUpdateWarehouseRequest,
  IUpdateZoneRequest,
  IUser,
  IWarehouse,
  IZone,
  IZoneTemperature,
} from "model";

export const prefix = "MASTER_DATA_CONFIGURATION";

/**
 * @WAREHOUSE actions
 */
export const getAllWarehouses = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IWarehouse[]>
>(prefix, "GET_ALL_WAREHOUSES");
export const getWarehouseById = ReduxHelper.generateActions<
  IGetByIdRequest,
  IWarehouse
>(prefix, "GET_WAREHOUSE_BY_ID");
export const createWarehouse = ReduxHelper.generateActions<
  ICreateWarehouseRequest,
  IWarehouse
>(prefix, "CREATE_WAREHOUSE");
export const updateWarehouse = ReduxHelper.generateActions<
  IUpdateWarehouseRequest,
  IWarehouse
>(prefix, "UPDATE_WAREHOUSE");
export const deleteWarehouse = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  any
>(prefix, "DELETE_WAREHOUSE");
export const clearCurrentWarehouse = ReduxHelper.generateLocalAction<undefined>(
  prefix,
  "CLEAR_CURRENT_WAREHOUSE"
);

/**
 * @PRODUCT actions
 */
export const getAllProducts = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IProduct[]>
>(prefix, "GET_ALL_PRODUCTS");
export const getProductById = ReduxHelper.generateActions<
  IGetByIdRequest,
  IProduct
>(prefix, "GTE_PRODUCT_BY_ID");
export const createProduct = ReduxHelper.generateActions<
  ICreateProductRequest,
  IProduct
>(prefix, "CREATE_PRODUCT");
export const updateProduct = ReduxHelper.generateActions<
  IUpdateProductRequest,
  IProduct
>(prefix, "UPDATE_PRODUCT");
export const deleteProduct = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  any
>(prefix, "DELETE_PRODUCT");
export const clearCurrentProduct = ReduxHelper.generateLocalAction<undefined>(
  prefix,
  "CLEAR_CURRENT_PRODUCT"
);

/**
 * @PALLET actions
 */
export const getAllPallets = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IPallet[]>
>(prefix, "GET_ALL_PALLETS");
export const createPallets = ReduxHelper.generateActions<
  ICreatePalletsRequest,
  IPallet
>(prefix, "CREATE_PALLETS");

/**
 * @LOCATION actions
 */
export const getAllLocations = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<any>
>(prefix, "GET_ALL_LOCATIONS");
export const createLocation = ReduxHelper.generateActions<
  ICreateLocationRequest,
  ILocation
>(prefix, "CREATE_LOCATION");
export const updateLocation = ReduxHelper.generateActions<
  IUpdateLocationRequest,
  ILocation
>(prefix, "UPDATE_LOCATION");
export const deleteLocation = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  any
>(prefix, "DELETE_LOCATION");

/**
 * @ZONE actions
 */
export const getAllZones = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IZone[]>
>(prefix, "GET_ALL_ZONES");
export const createZone = ReduxHelper.generateActions<
  ICreateZoneRequest,
  IZone
>(prefix, "CREATE_ZONE");
export const updateZone = ReduxHelper.generateActions<
  IUpdateZoneRequest,
  IZone
>(prefix, "UPDATE_ZONE");
export const deleteZone = ReduxHelper.generateActions<IDeleteByIdRequest, any>(
  prefix,
  "DELETE_ZONE"
);

/**
 * @COMPANY actions
 */
export const getAllCompanies = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<ICompany[]>
>(prefix, "GET_ALL_COMPANIES");
export const getCompanyById = ReduxHelper.generateActions<
  IGetByIdRequest,
  ICompany
>(prefix, "GET_COMPANY_BY_ID");
export const createCompany = ReduxHelper.generateActions<
  ICreateCompanyRequest,
  ICompany
>(prefix, "CREATE_COMPANY");
export const updateCompany = ReduxHelper.generateActions<
  IUpdateCompanyRequest,
  ICompany
>(prefix, "UPDATE_COMPANY");
export const deleteCompany = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  any
>(prefix, "DELETE_COMPANY");
export const clearCurrentCompany = ReduxHelper.generateLocalAction<undefined>(
  prefix,
  "CLEAR_CURRENT_COMPANY"
);

/**
 * @USER actions
 */
export const getAllUsers = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IUser[]>
>(prefix, "GET_ALL_USERS");
export const getUserById = ReduxHelper.generateActions<IGetByIdRequest, IUser>(
  prefix,
  "GET_USER_BY_ID"
);
export const createUser = ReduxHelper.generateActions<
  ICreateUserRequest,
  IUser
>(prefix, "CREATE_USER");
export const updateUser = ReduxHelper.generateActions<
  IUpdateUserRequest,
  IUser
>(prefix, "UPDATE_USER");
export const deleteUser = ReduxHelper.generateActions<IDeleteByIdRequest, any>(
  prefix,
  "DELETE_USER"
);
export const clearCurrentUser = ReduxHelper.generateLocalAction<undefined>(
  prefix,
  "CLEAR_CURRENT_USER"
);

/**
 * @COMMON actions
 */
export const getProductCategories = ReduxHelper.generateActions<
  undefined,
  IProductCategory[]
>(prefix, "GET_PRODUCT_CATEGORIES");
export const getUnitMeasure = ReduxHelper.generateActions<
  undefined,
  IUnitMeasure[]
>(prefix, "GET_UNIT_MEASURE");
export const getZoneTemperature = ReduxHelper.generateActions<
  undefined,
  IZoneTemperature[]
>(prefix, "GET_ZONE_TEMPERATURE");
